export default __webpack_public_path__ + "static/logo-vertical-93d4f8c1f7656383dd93cf885a78da73.svg";